import { render, staticRenderFns } from "./EditorAssignmentsTableControls.vue?vue&type=template&id=75d212d3&scoped=true&"
import script from "./EditorAssignmentsTableControls.vue?vue&type=script&lang=js&"
export * from "./EditorAssignmentsTableControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d212d3",
  null
  
)

export default component.exports